
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as new2lbrRDR5_A2rGupTxFdapewxKEBCYEH2kr3E9DR_45wI8Meta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/new.vue?macro=true";
import { default as logAjcKKd5QuzJ2zcC5x6ElOkFAtgeCKzGVsJsv5zFxB10Meta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/log.vue?macro=true";
import { default as flags7mndvT_OavuSBFYovYK5NjdaSwRP12I3K395_45hr3I78Meta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/flags.vue?macro=true";
import { default as statsBhECCN59Nlgo0krOY2PnxRx4A_45jDOfvLXZniuUs8bFgMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/stats.vue?macro=true";
import { default as healthoSYEw7epkfu39bPeYrtfPmHYyw_459okrT1WYRpCke_AgMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/health.vue?macro=true";
import { default as settingsoylvOEo7K2quFHpibKdt_45sJFYPuGem4yc6GLQuaHR7kMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/settings.vue?macro=true";
import { default as indexzQfWev7_8JyYeKimcMlYVvVyZt8GxdyRo6EbFCo7Sq8Meta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/user/index.vue?macro=true";
import { default as _91user_93_0h1yp8CyDGFjpYVQ6GXB2oq9fS_45VD2ZZfypUvifKRQMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/user/[user].vue?macro=true";
import { default as _91user_93DGCotBkqj5BHv_7_j3QAwShnw8YHv3PkiFGk4wZbuOQMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/activities/[user].vue?macro=true";
import { default as projectsl5O6bUSy_38vU4TnrJpckBNMxhjbNWt_45OD3llss0yxYMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/approval/projects.vue?macro=true";
import { default as versions8dt38XR_dI9g465bOZqbi4wYnmxysYyaka_NMVzzR18Meta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/approval/versions.vue?macro=true";
import { default as admingVSLprLsfaNjM637FP6GuirAjOcYsR_45Pv2ilSY0XMbgMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/admin.vue?macro=true";
import { default as errorrAojJU_45RLrsb9zIkIbZ1UX0AZ_Tik5VbNmFdPYOlIY8Meta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/error.vue?macro=true";
import { default as index8KdbT4SptJfMTu1_45WSn9T6VV3Mp3dAJXfeCv9bCNOZwMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/index.vue?macro=true";
import { default as paperSuFMGBsgizWFFilMQwZwhqK5vW_LAY00pSuiBAwSarUMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/paper.vue?macro=true";
import { default as staffrjOdwyusEmLm76tLgNEvpKh_7Bx_45SLN_shEjIGRf0qwMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/staff.vue?macro=true";
import { default as termsyhm_45QqMuUUpnNqUZwY4WEKwN8LPJVPDgKMSrgmXN35sMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/terms.vue?macro=true";
import { default as indexL4k0jMkWoLF7AJLpJBQJMqDqHTZlMHA5EVgJLo5gMGIMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/index.vue?macro=true";
import { default as flagskpbMsQbkDs_Hrqmvwiyc_SmF_45ucSZkKVGKIr_u2gmvwMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/flags.vue?macro=true";
import { default as index_45dhhYnmPtDrLksaqUw6cw9cdieKK9ljHC_45tEdSQK6S8Meta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/index.vue?macro=true";
import { default as notesi2K700KmoOS2W_45ia5lCPYD2OQ98ilWger_454Ze49lJk4Meta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/notes.vue?macro=true";
import { default as starsTSvV9UURTmoBBet9Ga7aKUifot0gSE4_45Z5rv_e9iRXAMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/stars.vue?macro=true";
import { default as discussbOFXJvgeqpGoVD7iAiVciUG8S_1P3S_45AavAq_PKxPV0Meta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/discuss.vue?macro=true";
import { default as channelso0F5yPHzDL66saSE_9A0N86vFezQGg3PY_45g_rlHQ1BkMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/channels.vue?macro=true";
import { default as watchersH07Dj3MZmAZZbraeoUwxbPdGyCici__H6ONhdhx0VBsMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/watchers.vue?macro=true";
import { default as newEu3rVd2agI_45e5xA0TWCma5CKN03lDN_45GsgMY_d9odk4Meta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/versions/new.vue?macro=true";
import { default as indexMBJcZaRcxUYMe0H94ecgtTgdkURkrcaecw6dQnlbDwEMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/versions/index.vue?macro=true";
import { default as _91_46_46_46page_93qq6zg9VdR5v3vblD14LBoaIWd6n_dGDyCPIjaOvfJkMMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/pages/[...page].vue?macro=true";
import { default as _91_46_46_46slug_93dHB0wASg7zsdZwK1FbsKcRLY21_45fRh_45kaQhUIhkCAVsMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/settings/[...slug].vue?macro=true";
import { default as scanhYHs9VrzYyucQCWht2djli2jh8CVmt_45utmq1UJymqgsMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/versions/[version]/scan.vue?macro=true";
import { default as indexA9Q7RXHEoVxxR_h2Fc_3sOB_wvMxmkoQhzXzzSU8PKMMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/versions/[version]/index.vue?macro=true";
import { default as reviewsFbUcpEgcSVHivupyfS7PWT4O2botsQLg1fNry4XKz8AMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/versions/[version]/reviews.vue?macro=true";
import { default as _91version_93kVw2Lu7omxH45mJvSHhECHTyvxFdvV9FX_8qzGit2XoMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/versions/[version].vue?macro=true";
import { default as _91project_935ukzELAOjdbXD0CaAcVgGOgxB5p4k6skRmCuG8TUoIMMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project].vue?macro=true";
import { default as _91user_93fUBY6EjIVTT405fKgO1Ub0ysw9YZpmx7e30WoI_KwQMMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/[user].vue?macro=true";
import { default as authors4cMGqPHqlB3OK_45D6PJgX3tv0HTX0b5Ao7AVNsLnfglsMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/authors.vue?macro=true";
import { default as linkoutyUN4g2F5QxscQ95BtHz9t4DAE2lHXs9oUO9noJLclVwMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/linkout.vue?macro=true";
import { default as privacy4dx7Q5bLIA_45c_4573Q8kYcSXB30oxT_45LHe0yv3H86FVP8Meta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/privacy.vue?macro=true";
import { default as version9TYSAS06jfe0K__z3OUquTPfMltDKeMkz1I7HXn0lLEMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/version.vue?macro=true";
import { default as api_45docs7MIPSH7FtetChPnISQOphjScuFGloATT_dHCtl9Zg9cMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/api-docs.vue?macro=true";
import { default as velocityw_xRRa41EjwOfV_2rhqWCTb7PI2aG84UPixSPg2S4QkMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/velocity.vue?macro=true";
import { default as waterfall_45Ye6xkZyBft3IvIujvAdmmztkQDbDeM1QOYdqSCFyagMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/waterfall.vue?macro=true";
import { default as loginT9um0p_IQHKsU3Qli94Fav8VWEWnVF1RndIJlx_45Xrk8Meta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/login.vue?macro=true";
import { default as resetdIm9VFeEp0Z3ptr5z5Rwc4mWT6d2ciGD6IPj2gmEacMMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/reset.vue?macro=true";
import { default as guidelinesHD44ve19goV2NaXru4iQvS7_sHSh9jHRbgwG6jnxSqQMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/guidelines.vue?macro=true";
import { default as onboardingkTY5iJhNrZhn4J_45iPh05zf314KckSlxraUkGadQJmHcMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/onboarding.vue?macro=true";
import { default as signupj2Aog_i_45OX_45Jh2OJ9sYdDi8LRT86II0kDX026W1HZegMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/signup.vue?macro=true";
import { default as bbcodebPUlFOLZy4aws_45m_45DFIlW3mg5nBvvGrA9wSKyqtcPHIMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/tools/bbcode.vue?macro=true";
import { default as other72MzTi8jxnPpBN_imhWcNUj8SyOxXb7sXGArgrtYLPcMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/settings/other.vue?macro=true";
import { default as accountBnZ_45n50eZpLv9PME4Qb2T_TqghcA_5FKoM75xD33HmsMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/settings/account.vue?macro=true";
import { default as profileRccKxYAg4b_9r8D26QWqMh_45dnZqPn3LXRvq_45WbZ494gMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/settings/profile.vue?macro=true";
import { default as api_45keysryv8aTJfsOkcVqUsRZDGCAExBHShz_45ukDu7FZWe_45_45sYMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/settings/api-keys.vue?macro=true";
import { default as securityXq31T7bdcjjZ1u9CBQE4_45AEVLVhLlXG0dyDsNwox4A8Meta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/settings/security.vue?macro=true";
import { default as settingsZrpiYAEbgvGIB44hVv_f5YN_WitHsi4GtbJmbth1EfkMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/settings.vue?macro=true";
import { default as notificationsmkaGBpONnb8KAa3u98nYQaiYHnRP9pbP7keYbCeoNzEMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/notifications.vue?macro=true";
import { default as importerejVKKT8FvyX2aiNTgnKJlm0bVNYB_45zFygVLA4Hm5i0sMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/tools/importer.vue?macro=true";
import { default as markdownpDQTVWTTWcbE544_4NWJUNPqol9P5XexU8jLa5FbW5IMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/tools/markdown.vue?macro=true";
import { default as neworganizationfzMJ9agTL_LZWYBWfMa2zp3eLmWfMsH66cwoMvTxjScMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/neworganization.vue?macro=true";
import { default as oauth_45signup5IMfO7caaPuEZ88YvW_fHgjUSglFZT3rVa2TQc9aBiQMeta } from "/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/oauth-signup.vue?macro=true";
export default [
  {
    name: "new",
    path: "/new",
    meta: new2lbrRDR5_A2rGupTxFdapewxKEBCYEH2kr3E9DR_45wI8Meta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/new.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/admin.vue"),
    children: [
  {
    name: "admin-log",
    path: "log",
    meta: logAjcKKd5QuzJ2zcC5x6ElOkFAtgeCKzGVsJsv5zFxB10Meta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/log.vue")
  },
  {
    name: "admin-flags",
    path: "flags",
    meta: flags7mndvT_OavuSBFYovYK5NjdaSwRP12I3K395_45hr3I78Meta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/flags.vue")
  },
  {
    name: "admin-stats",
    path: "stats",
    meta: statsBhECCN59Nlgo0krOY2PnxRx4A_45jDOfvLXZniuUs8bFgMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/stats.vue")
  },
  {
    name: "admin-health",
    path: "health",
    meta: healthoSYEw7epkfu39bPeYrtfPmHYyw_459okrT1WYRpCke_AgMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/health.vue")
  },
  {
    name: "admin-settings",
    path: "settings",
    meta: settingsoylvOEo7K2quFHpibKdt_45sJFYPuGem4yc6GLQuaHR7kMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/settings.vue")
  },
  {
    name: "admin-user",
    path: "user",
    meta: indexzQfWev7_8JyYeKimcMlYVvVyZt8GxdyRo6EbFCo7Sq8Meta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/user/index.vue")
  },
  {
    name: "admin-user-user",
    path: "user/:user()",
    meta: _91user_93_0h1yp8CyDGFjpYVQ6GXB2oq9fS_45VD2ZZfypUvifKRQMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/user/[user].vue")
  },
  {
    name: "admin-activities-user",
    path: "activities/:user()",
    meta: _91user_93DGCotBkqj5BHv_7_j3QAwShnw8YHv3PkiFGk4wZbuOQMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/activities/[user].vue")
  },
  {
    name: "admin-approval-projects",
    path: "approval/projects",
    meta: projectsl5O6bUSy_38vU4TnrJpckBNMxhjbNWt_45OD3llss0yxYMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/approval/projects.vue")
  },
  {
    name: "admin-approval-versions",
    path: "approval/versions",
    meta: versions8dt38XR_dI9g465bOZqbi4wYnmxysYyaka_NMVzzR18Meta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/admin/approval/versions.vue")
  }
]
  },
  {
    name: "error",
    path: "/error",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/index.vue")
  },
  {
    name: "paper",
    path: "/paper",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/paper.vue")
  },
  {
    name: "staff",
    path: "/staff",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/staff.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/terms.vue")
  },
  {
    name: _91user_93fUBY6EjIVTT405fKgO1Ub0ysw9YZpmx7e30WoI_KwQMMeta?.name,
    path: "/:user()",
    meta: _91user_93fUBY6EjIVTT405fKgO1Ub0ysw9YZpmx7e30WoI_KwQMMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/[user].vue"),
    children: [
  {
    name: "user",
    path: "",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/index.vue")
  },
  {
    name: _91project_935ukzELAOjdbXD0CaAcVgGOgxB5p4k6skRmCuG8TUoIMMeta?.name,
    path: ":project()",
    meta: _91project_935ukzELAOjdbXD0CaAcVgGOgxB5p4k6skRmCuG8TUoIMMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project].vue"),
    children: [
  {
    name: "user-project-flags",
    path: "flags",
    meta: flagskpbMsQbkDs_Hrqmvwiyc_SmF_45ucSZkKVGKIr_u2gmvwMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/flags.vue")
  },
  {
    name: "user-project",
    path: "",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/index.vue")
  },
  {
    name: "user-project-notes",
    path: "notes",
    meta: notesi2K700KmoOS2W_45ia5lCPYD2OQ98ilWger_454Ze49lJk4Meta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/notes.vue")
  },
  {
    name: "user-project-stars",
    path: "stars",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/stars.vue")
  },
  {
    name: "user-project-discuss",
    path: "discuss",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/discuss.vue")
  },
  {
    name: "user-project-channels",
    path: "channels",
    meta: channelso0F5yPHzDL66saSE_9A0N86vFezQGg3PY_45g_rlHQ1BkMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/channels.vue")
  },
  {
    name: "user-project-watchers",
    path: "watchers",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/watchers.vue")
  },
  {
    name: "user-project-versions-new",
    path: "versions/new",
    meta: newEu3rVd2agI_45e5xA0TWCma5CKN03lDN_45GsgMY_d9odk4Meta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/versions/new.vue")
  },
  {
    name: "user-project-versions",
    path: "versions",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/versions/index.vue")
  },
  {
    name: "user-project-pages-page",
    path: "pages/:page(.*)*",
    meta: _91_46_46_46page_93qq6zg9VdR5v3vblD14LBoaIWd6n_dGDyCPIjaOvfJkMMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/pages/[...page].vue")
  },
  {
    name: "user-project-settings-slug",
    path: "settings/:slug(.*)*",
    meta: _91_46_46_46slug_93dHB0wASg7zsdZwK1FbsKcRLY21_45fRh_45kaQhUIhkCAVsMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/settings/[...slug].vue")
  },
  {
    name: _91version_93kVw2Lu7omxH45mJvSHhECHTyvxFdvV9FX_8qzGit2XoMeta?.name,
    path: "versions/:version()",
    meta: _91version_93kVw2Lu7omxH45mJvSHhECHTyvxFdvV9FX_8qzGit2XoMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/versions/[version].vue"),
    children: [
  {
    name: "user-project-versions-version-scan",
    path: "scan",
    meta: scanhYHs9VrzYyucQCWht2djli2jh8CVmt_45utmq1UJymqgsMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/versions/[version]/scan.vue")
  },
  {
    name: "user-project-versions-version",
    path: "",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/versions/[version]/index.vue")
  },
  {
    name: "user-project-versions-version-reviews",
    path: "reviews",
    meta: reviewsFbUcpEgcSVHivupyfS7PWT4O2botsQLg1fNry4XKz8AMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/[user]/[project]/versions/[version]/reviews.vue")
  }
]
  }
]
  }
]
  },
  {
    name: "authors",
    path: "/authors",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/authors.vue")
  },
  {
    name: "linkout",
    path: "/linkout",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/linkout.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/privacy.vue")
  },
  {
    name: "version",
    path: "/version",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/version.vue")
  },
  {
    name: "api-docs",
    path: "/api-docs",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/api-docs.vue")
  },
  {
    name: "velocity",
    path: "/velocity",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/velocity.vue")
  },
  {
    name: "waterfall",
    path: "/waterfall",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/waterfall.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/login.vue")
  },
  {
    name: "auth-reset",
    path: "/auth/reset",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/reset.vue")
  },
  {
    name: "guidelines",
    path: "/guidelines",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/guidelines.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/onboarding.vue")
  },
  {
    name: "auth-signup",
    path: "/auth/signup",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/signup.vue")
  },
  {
    name: "tools-bbcode",
    path: "/tools/bbcode",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/tools/bbcode.vue")
  },
  {
    name: "auth-settings",
    path: "/auth/settings",
    meta: settingsZrpiYAEbgvGIB44hVv_f5YN_WitHsi4GtbJmbth1EfkMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/settings.vue"),
    children: [
  {
    name: "auth-settings-other",
    path: "other",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/settings/other.vue")
  },
  {
    name: "auth-settings-account",
    path: "account",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/settings/account.vue")
  },
  {
    name: "auth-settings-profile",
    path: "profile",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/settings/profile.vue")
  },
  {
    name: "auth-settings-api-keys",
    path: "api-keys",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/settings/api-keys.vue")
  },
  {
    name: "auth-settings-security",
    path: "security",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/settings/security.vue")
  }
]
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsmkaGBpONnb8KAa3u98nYQaiYHnRP9pbP7keYbCeoNzEMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/notifications.vue")
  },
  {
    name: "tools-importer",
    path: "/tools/importer",
    meta: importerejVKKT8FvyX2aiNTgnKJlm0bVNYB_45zFygVLA4Hm5i0sMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/tools/importer.vue")
  },
  {
    name: "tools-markdown",
    path: "/tools/markdown",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/tools/markdown.vue")
  },
  {
    name: "neworganization",
    path: "/neworganization",
    meta: neworganizationfzMJ9agTL_LZWYBWfMa2zp3eLmWfMsH66cwoMvTxjScMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/neworganization.vue")
  },
  {
    name: "auth-oauth-signup",
    path: "/auth/oauth-signup",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/src/pages/auth/oauth-signup.vue")
  }
]